import axios from 'axios';

const libraryBook = {
    namespaced: true,
    
	actions: {		
		ProcessLibraryBook(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/LibraryBook/ProcessLibraryBook', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 		
		GetLibraryBook({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBook/GetLibraryBook?Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}, 
		GetByIdLibraryBook({rootState}, Id){
			return new Promise((resolve, reject) => {				
				axios.get(`/LibraryBook/GetByIdLibraryBook?Id=${Id}&Username=${rootState.auth.username}&Accesskey=${rootState.auth.accesskey}`)
				.then(resp => resp.data)
				.then(respdata => {									
					resolve(respdata)
				})
				.catch(err => {
					reject(err)
				})
			})
		}
	}
}

export default libraryBook